module.exports = __webpack_public_path__ + "static/media/fastag.3db842ff.svg";